import { Component, Inject, Input } from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu'
import {
  appNameToken,
  LanguageIconComponent,
  logoAssetsToken,
  ThemeIconComponent,
} from 'shared-components'
import { LogoAssets } from 'shared-components'
import { LeaveGamePlayComponent } from '../leave-game-play/leave-game-play.component'

@Component({
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    ThemeIconComponent,
    LanguageIconComponent,
    LeaveGamePlayComponent,
  ],
  selector: 'sans-play-toolbar-links',
  templateUrl: './play-toolbar-links.component.html',
  styleUrls: ['./play-toolbar-links.component.scss'],
})
export class PlayToolbarLinksComponent {
  @Input() public gamePlayId = ''

  public constructor(
    @Inject(appNameToken) public readonly appName: string,
    @Inject(logoAssetsToken) public readonly logoAssets: LogoAssets,
  ) {}
}
